export function tracking() {
	var sessionKey = "bett-consent-20220412";
	var hasConsented = !!window.localStorage.getItem(sessionKey);
	var consentBanner = document.getElementById("consent");
	var acceptButton = document.getElementById("accept");

	function gaCode() {
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag("js", new Date());

		gtag("config", "G-PNV7ENHBJ3");
	}

	if (!hasConsented) {
		consentBanner.classList.remove("hidden");
	} else {
		gaCode();
	}

	acceptButton.addEventListener("click", function () {
		window.localStorage.setItem(sessionKey, new Date().getTime());
		consentBanner.classList.add("hidden");
		gaCode();
	});
}
